<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
  name: "ShiftOverlay",
  setup(props) {
    const shift = props.shift;
    
    return {shift}
  },
  props: {
    shift: {
      type: Object,
      default: null,
    },
  },
  methods: {
    onCancel() {
      this.$emit('shift-back', false);
    }
  }
})
</script>

<template>
  <v-container class="container py-6 d-flex align-center justify-center bg-white flex-column">
    <h3 class="mb-8">Schicht Eingabe</h3>
    <v-row class="w-100">
      <v-col>
        <v-text-field label="Schichtname" v-model="shift.name"></v-text-field>
      </v-col>
    </v-row>
    <v-row class="w-100">
      <v-col class="mx-4">
        <v-text-field label="SchichtNr" v-model="shift.nr"></v-text-field>
      </v-col>
      <v-col class="mx-4">
        <v-text-field label="Maximum" v-model="shift.max"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn @click="onCancel">Zurück</v-btn>
      </v-col>
    </v-row>
  </v-container>  
</template>

<style scoped>
.container {
  border-radius: 5px;
  background: white;
}
</style>